export let partyColors = [
    {color: '#FFCA99', name: ['Agrárszövetség', 'Agrárszövetség – Nemzeti Agrár Párt'] },
    {color: '#c6adb3', name: ['Centrum', 'Centrum Párt'] },
    {color: '#007FFF', name: ['DK', 'Demokratikus Koalíció'] },
    {color: '#00daff', name: ['Együtt', 'Együtt – a Korszakváltók Pártja'] },
    {color: '#9acd32', name: ['EKGP', 'Egyesült Kisgazda Párt'] },
    {color: '#fd8100', name: ['Fidesz', 'Fidesz – Magyar Polgári Szövetség'] },
    {color: '#445F2B', name: ['FKGP', 'Független Kisgazda-, Földmunkás- és Polgári Párt'] },
    {color: '#BF3F3F', name: ['horvátok', 'Magyarországi Horvátok Szövetsége'] },
    {color: '#008371', name: ['Jobbik', 'Jobbik Magyarországért Mozgalom'] },
    {color: '#cd9a01', name: ['KDNP', 'Kereszténydemokrata Néppárt'] },
    {color: '#9ED144', name: ['KPE', 'Kisgazda Polgári Egyesület'] },
    {color: '#91A4D5', name: ['Köztársaság', 'Köztársaság Párt'] },
    {color: '#73c92d', name: ['LMP', 'Lehet Más a Politika'] },
    {color: '#3C8A5A', name: ['MDF', 'Magyar Demokrata Fórum'] },
    {color: '#046731', name: ['MDNP', 'Magyar Demokrata Néppárt'] },
    {color: '#9E863E', name: ['MIÉP', 'Magyar Igazság és Élet Pártja'] },
    {color: '#688d1b', name: ['Mi Hazánk', 'Mi Hazánk Mozgalom'] },
    {color: '#62A26A', name: ['MKDSZ', 'Magyar Kereszténydemokrata Szövetség'] },
    {color: '#CD5C5C', name: ['MSZDP', 'Magyarországi Szociáldemokrata Párt'] },
    {color: '#E71A29', name: ['MSZP', 'Magyar Szocialista Párt'] },
    {color: '#8b0000', name: ['Munkáspárt', 'Magyar Munkáspárt', 'MSZMP'] },
    {color: '#97a6a6', name: ['németek', 'Magyarországi Németek Szövetsége'] },
    {color: '#74c6c3', name: ['NOE', 'Nagycsaládosok Országos Egyesülete'] },
    {color: '#37B34A', name: ['PM', 'Párbeszéd Magyarországért'] },
    {color: '#0783C7', name: ['SZDSZ', 'Szabad Demokraták Szövetsége'] },
    {color: '#C8A52C', name: ['VP', 'Vállalkozók Pártja'] },
    {color: '#0080bd', name: ['MoMa', 'Modern Magyarország Mozgalom'] },
    {color: '#808080', name: ['MKKP', 'Magyar Kétfarkú Kutya Párt'] },
    {color: '#001166', name: ['MMM', 'Mindenki Magyarországa'] },
    {color: '#8e6fcd', name: ['Momentum', 'Momentum mozgalom'] },
];
